import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import './VolumeItem.scss';
import InkyPenArrow from '../../../../InkyPenUIKit/InkyPenArrow/InkyPenArrow';
import SideVolume from '../../SideVolume/SideVolume';
import { Product } from '../../../../../Models/Product';
import { Series } from '../../../../../Models/Series';
import { LoginOverlayVisible } from '../../../../../store/OverlayStore';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { AddToCartAction, UpdatingCartAtom } from '../../../../../store/CartStore';
import { useHistory } from 'react-router-dom';
import { Link } from '../../../../../Devon/Components/InkyLink';
import { AccountInfoAtom, LoginStatusAtom } from '../../../../../store/AccountStore';
import { Cart } from '../../../../../Models/Cart';
import SimulPubItem from '../../SimulPub/SimulPubItem';
import Log from '../../../../Services/Logger';
import apiClient from '../../../../../API/InkyAPI';
import AnalyticsEvent from '../../../../../Models/Analytics/AnalyticsEvent';
import { AnalyticsIdAtom, AnalyticsUserProxyAtom } from '../../../../../store/AnalyticsStore';
import { ProductItem } from '../../../Product/VolumesWheel/ProductItem';
import { Variant } from '../../../../../Models/Product/Variant';
import { VariantType } from '../../../../../Models/CartItem';
import { SubscriptionStatusType } from '../../../../../Models/AccountInfo';
import { isSubscribed } from '../../../../Hooks/AuthUtils';

interface ReadOrPurchaseButtonProps {
    product: Product;
    showIfDisabled?: boolean;
    className?: string;
    text?: string;
    onClick?: () => any;
    variant?: Variant;
}

export function ReadOrPurchaseButton(props: ReadOrPurchaseButtonProps): JSX.Element {
    const [cart,addToCart] = useAtom(AddToCartAction);
    const updatingCart = useAtomValue(UpdatingCartAtom);
    const loginStatus = useAtomValue(LoginStatusAtom);
    const setLoginOverlay = useSetAtom(LoginOverlayVisible);
    const sessionId = useAtomValue(AnalyticsIdAtom);
    const history = useHistory()
    const [accountInfo] = useAtom(AccountInfoAtom);
    const [analyticsUserProxy] = useAtom(AnalyticsUserProxyAtom);

    async function trackAddToCart(product): Promise<void> {
        const productId = product.id;
        await apiClient.sendEvent(accountInfo,new AnalyticsEvent(sessionId.toString(), 'ADD_CART', window.location.pathname, productId, analyticsUserProxy.toString()))
            .then(res => {
                console.log(res);
            }).catch(e => {
            console.error(e);
        });
    }

    async function addItemToCart(product, variant?: Variant) {
        if(updatingCart) {
            return;
        }
        if(variant){
            await addToCart({ productId: product.id, variantId: variant.id });
        } else {
            await addToCart({ productId: product.id, variantId: product.variants[0].id });
        }

        await trackAddToCart(product);
    }


    function ReadButton() {
        const history = useHistory();
        return (
            <div className='read-button-wrapper'>
                <Link to={`/reader/${props.product.id}`} className='read-button-style'>
                    Read
                </Link>
            </div>
            // <InkyPenArrow bold text={"Read"} styles={props.className + ' read-button-style'}
            //               fill={true}
            //               withArrow={false}
            //               onClick={() =>{
            //                    history.push(`/reader/${props.product.id}`, { returnPath: history.location.pathname });
            //                }}
            // />
        );
    }

    function SignUpToReadButton() {
        const setLoginOverlay = useSetAtom(LoginOverlayVisible);

        return (
            <InkyPenArrow bold text={props.text ?? "FREE WITH ACCOUNT"} styles={props.className  + ' ' + 'sign-up-to-read-button-style'}
                          withArrow={false}
                          onClick={() => setLoginOverlay(true)} />
        );
    }

    function renderBuyButton(buttonText: string, variant?: Variant) {
        if( cart && variant?.isInStock === false){
            return (
                getDisabledButton("Out Of Stock")
            )
        }if( cart && variant?.cartLimit !== null && variant?.cartLimit != undefined&&cart.amountOfProductVariant(props.product,props.variant)>= variant.cartLimit){
            return (
                getDisabledButton("Buy Print")
            )
        }
        return (
            <InkyPenArrow bold text={buttonText} styles={props.className}
                          fill={true}
                           // styles={`expand-for-buy ${props.product.hasChapters() && 'series-volume-arrow-btn-desktop-new-style-100'} series-volume-arrow-btn-desktop-new-style 'add-hover-to-button`}
                          withArrow={false}
                          onClick={() => addItemToCart(props.product, variant).then(() => {
                               Log.info('Item added');
                           }).catch((e) => {
                               Log.error('Item not added', e);
                           })}
            />
        );
    }


    function getDisabledButton(buttonText: string) {
        if(!props.showIfDisabled) {
            return null;
        }
        return (
            <InkyPenArrow fill={true} bold text={buttonText} active={false} withArrow={false} ignoreActive styles={props.className} />
        );
    }


    const defaultVariant = props.product.getDefaultVariant();

    if(updatingCart || loginStatus === "LoggingIn") {
        return getDisabledButton("...");
    }

    // Add Physical variant
    if(props.variant?.type == VariantType.Print){
        return renderBuyButton("Buy Print", props.variant);
    }

    if (props.variant?.priceType === 'Free') {
        console.log('It\'s free');
        return (
            <ReadButton />
        );
    }

    if (isSubscribed(accountInfo)) {
        return (
            <ReadButton />
        );
    }

    if(props.product?.canReadDigitalByUser(loginStatus === "LoggedIn")) {
        return (
            <ReadButton/>
        )
    }

    if(!defaultVariant || defaultVariant.priceType === 'NotForSale') {
        return <InkyPenArrow text={'Find Retailer'} active={true} withArrow={false} styles={props.className} onClick={props.onClick}/>
    }

    if(defaultVariant.isComingSoon) {
        return getDisabledButton("Coming Soon");
    }

    if(cart && (cart as Cart).containsProductVariant(props.product, defaultVariant)) {
        return getDisabledButton("Read");
    }

    if(loginStatus == "LoggedOut" && defaultVariant.priceType === "FreeForRegistered") {
        return(<SignUpToReadButton/>);
    }

    if(defaultVariant.isPreOrder) {
        return renderBuyButton("Pre-Order");
    }

    //Must be purchaseable.
    return renderBuyButton("Read");


}

interface VolumeItemProps {
    hasDivider?: boolean;
    isFirst?: boolean;
    product?: Product;
    series?: Series;
    index?: number;
    showChapters?: boolean;
    isLast?: boolean;
}

const VolumeItem = (props: VolumeItemProps): ReactElement => {
    const [isChaptersOn, setIsChaptersOn] = useState(props.showChapters);

    const onChaptersViewClick = (): void => {
        setIsChaptersOn(state => !state);
    };

    useEffect(() =>{
        setIsChaptersOn(props.showChapters);
    }, [props.showChapters]);

    const chaptersLength = useMemo(() => props.product?.chapters?.length, [props.product])
    const hasChapters = useMemo(() => props.showChapters && (chaptersLength !== 0), [chaptersLength, props.showChapters]) // Refers to has chapters and the show chapters is on, for abbreviation has been written "hasChapters"

    function ShowChapters(): JSX.Element {
        if(!isChaptersOn) {
            return null;
        }

        return (
            <div className='series-volume-side-volume-container'>
                <SideVolume volumeNumber={props.product?.volumeNumber}
                            childAsRenderedProps={props.product?.chapters?.map((chapter) => {
                                // childAsRenderedProps={mock[0]?.chapters?.map((chapter) => {
                                return <SimulPubItem isInkypenPlus={false}
                                                     chapter={chapter}
                                                     showPublishDate
                                />;
                            })} />
            </div>
        );
    }


    return (
            <div
                id={'volume-' + props.index.toString()}
                className='series-volume-item-top-container series-volume-item-top-container-desktop'
            >
                <div className={`series-volume-item-container ${!props.showChapters ? 'series-volume-item-container-normal' : (hasChapters ? 'series-volume-item-container-with-chapters' : 'series-volume-item-container-no-chapter')}`}>
                    <ProductItem product={props.product} showChapters={props.showChapters} hasChapters={hasChapters}/>
                    {props.product.subCategory !== 'Book' && props.product.hasChapters() &&
                    <div onClick={onChaptersViewClick} className='series-volume-chapters-container'>
                        <span className='series-volume-chapters-plus'>{isChaptersOn ? '-' : '+'}</span>
                        <span className='series-volume-chapters-text'>{isChaptersOn ? 'HIDE ' : 'VIEW '} CHAPTERS</span>
                    </div>
                    }

                    <ShowChapters/>
                </div>

                {/*<div className='series-desktop-volume-divider' />*/}
                {/*{!props.isLast && <div className='series-desktop-volume-divider' />}*/}

            </div>
    );

};

export default VolumeItem;
